function hexStringToRgb(color) {
    // this is not a TS-friendly solution, but relies on the one we've been using for a while - please see link above
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const hex = +`0x${color.slice(1).replace(color.length < 5 && /./g, '$&$&')}`;
    const r = (hex >> 16) & 255; // eslint-disable-line no-bitwise
    const g = (hex >> 8) & 255; // eslint-disable-line no-bitwise
    const b = hex & 255; // eslint-disable-line no-bitwise

    return [r, g, b];
}

function rgbStringToRgb(color) {
    // source https://gist.github.com/stla/00d8d78c7daa8b774c484e5b6f5758ce
    const match = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);
    const [, r, g, b] = match;
    return [Number(r), Number(g), Number(b)];
}

export const stringToRgb = (color) => {
    return color.match(/^rgb/) ? rgbStringToRgb(color) : hexStringToRgb(color);
};

export const isLightColor = (color, threshold = 127.5) => {
    const [r, g, b] = stringToRgb(color);

    const brightness = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));

    return brightness > threshold;
};
